__turbopack_context__.v({
  "freeBox": "PlasmicLabel-module__3kHoPq__freeBox",
  "root": "PlasmicLabel-module__3kHoPq__root",
  "slotTargetChildrensize_lg": "PlasmicLabel-module__3kHoPq__slotTargetChildrensize_lg",
  "slotTargetChildrensize_sm": "PlasmicLabel-module__3kHoPq__slotTargetChildrensize_sm",
  "text": "PlasmicLabel-module__3kHoPq__text",
  "textrequirementIndicator_optional": "PlasmicLabel-module__3kHoPq__textrequirementIndicator_optional",
  "textrequirementIndicator_required": "PlasmicLabel-module__3kHoPq__textrequirementIndicator_required",
});
